import { render, staticRenderFns } from "./BundleProduct.vue?vue&type=template&id=46786e68&scoped=true&"
import script from "./BundleProduct.vue?vue&type=script&lang=ts&"
export * from "./BundleProduct.vue?vue&type=script&lang=ts&"
import style0 from "./BundleProduct.vue?vue&type=style&index=0&id=46786e68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46786e68",
  null
  
)

export default component.exports